/**
 * A funds list's order, as the API takes it. The Fund column sorts by its
 * foundation's name, a fund for all diseases first within it: two orders the
 * API declares (foundationName, diseaseType), sent one after the other in the
 * column's direction. Every other order is sent as it is.
 */
export function fundOrder(order: string): string {
  const [name, direction] = (order || '').split(',');

  return name === 'name'
    ? `foundationName,${direction};diseaseType,${direction}`
    : order;
}
